import {combineReducers} from 'redux';
import organizations from './adminOrganizationsReducer';
import users from './adminUsersReducer';

const adminReducer = combineReducers({
    organizations,
    users,
});

export default adminReducer;
